import React, { memo, useMemo } from 'react';
import cn from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { IconArrowLeft } from '@alfa-bank/site-icon/arrow-left';
// eslint-disable-next-line no-restricted-imports
import { IconArrowRight } from '@alfa-bank/site-icon/arrow-right';

import type { TArrow } from './models';
import styles from './styles.css';

export const Arrow = memo(({ Button, direction = 'left', onClick, shadow = true }: TArrow) => {
    const isLeft = direction === 'left';
    const Icon = isLeft ? IconArrowLeft : IconArrowRight;

    const Shadows = useMemo(() => {
        if (!shadow) return null;

        return isLeft ? (
            <div className={styles.leftShadowBlock}>
                <div className={cn(styles.shadow, styles.leftShadow)} />
            </div>
        ) : (
            <div className={styles.rightShadowBlock}>
                <div className={cn(styles.shadow, styles.rightShadow)} />
            </div>
        );
    }, [isLeft, shadow]);

    return (
        <>
            <Button
                hasAnimation={false}
                innerClassName={cn(
                    styles.button,
                    styles.narrowClass,
                    isLeft ? styles.left : styles.right
                )}
                onClick={onClick}
                view="ghost"
            >
                <Icon height={14} width={20} />
            </Button>
            {Shadows}
        </>
    );
});
